export default __webpack_public_path__ + "static/media/header.9ee5a121.jpg";